import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";

import Logo from "../assets/images/nav_logo.png";
import EnrollBtnAro from "../assets/images/enroll-btn-aro.png";
import "./Navbar.css";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  return (
    <div className={`navbar__container top-bar`}>
      <div className="navbar">
        <div className="header-left">
          <div className="navbar__logo">
            <Link to="/">
              <img src={Logo} alt="Logo" className="navbar__logo--image" />
            </Link>
          </div>
        </div>
        <div className="navbar__links">
          <a href="/" className="web--link">
            Home
          </a>
          <a href="#moduleenroll" className="web--link">
            Module
          </a>
          <a href="#blogid" className="web--link">
            Blogs
          </a>
          <a href="#footerid" className="web--link">
            Contact Us
          </a>            
        </div>         
        <div className="header-btns">
          <a href="https://pages.razorpay.com/ROBOAI-I90" target="_blank" className="header-enroll-btn">Enroll Now <img src={EnrollBtnAro} alt="" className="enroll-btn-aro" /></a>
        </div>

        <div className="navbar__ham" onClick={() => setIsMobileMenuOpen(true)}>
          <FontAwesomeIcon icon={faBars} color="#000" className="navbar__icon" />
        </div>

        {isMobileMenuOpen && (
         <div className="modal-overlay">
         <div
           style={{
             display: "flex",
             alignItems: "center",
             justifyContent: "space-between",
             marginBottom: "10px",
           }}
         >
           <div className="navbar__logo">
             <Link to="/">
               <img
                 src={Logo}
                 alt="Logo"
                 style={{ width: "160px", marginTop: "5px" }}
               />
             </Link>
           </div>
           <FontAwesomeIcon
             size="50px"
             icon={faClose}
             onClick={() => setIsMobileMenuOpen(false)}
             className="close-icon"
           />
         </div>
         <div className="modal">
          <a href="/" className="web--link">
            Home
          </a>
          <a href="#moduleenroll" className="web--link">
            Module
          </a>
          <a href="#blogid" className="web--link">
            Blogs
          </a>
          <a href="#footerid" className="web--link">
            Contact Us
          </a>  
         </div>
       </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;